export const restoreDragItems = (items = []) =>
  items.map((item) => ({
    ...item,
    box: item.originBox ? { ...item.originBox } : item.box,
  }));
